import { computed } from 'vue';
import store from '@/store';
import { getI18n } from '@/utils/i18n-helper';

export const TERRENOS_TEATRO_HASH = 'J1fKG9AarPuPNJ5hwY0t';

const PALABRAS_POR_IDIOMA = {
    es: { default: 'parcelas', terreno: 'terrenos' },
    en: { default: 'parcels', terreno: 'lands' },
    ca: { default: 'parcel·les', terreno: 'terrenys' },
    gl: { default: 'parcelas', terreno: 'terreos' },
    va: { default: 'parcel·les', terreno: 'terrenys' }
};

const FALLBACK = PALABRAS_POR_IDIOMA.es;

/**
 * Devuelve el término dinámico ("parcelas" o "terrenos") que el teatro actual
 * debe mostrar al usuario, en función de su hash y del idioma activo.
 *
 * - Default (la mayoría de teatros): "parcelas" / "parcels" / "parcel·les" / ...
 * - Teatro TERRENOS_TEATRO_HASH (club que vende "terrenos"): "terrenos" / "lands" / ...
 *
 * Pensado para Options API: el componente expone `setup()` que devuelve el
 * resultado de este composable, dejando `this.esTerreno` y `this.palabra`
 * disponibles en template y computed.
 *
 * Uso en template:
 *   {{ $t('parcelas.venta_parcelas', { parcela: palabra }) }}
 */
export function useParcelaWord() {
    const configuracion = computed(() => store.getters.getConfig);
    const i18n = getI18n();

    const esTerreno = computed(
        () => configuracion.value?.hash_teatro === TERRENOS_TEATRO_HASH
    );

    const palabra = computed(() => {
        const locale = i18n?.locale || 'es';
        const palabras = PALABRAS_POR_IDIOMA[locale] || FALLBACK;
        return esTerreno.value ? palabras.terreno : palabras.default;
    });

    return { esTerreno, palabra };
}
